import type { ScreenModule } from "../../../app/screen-module";
import { WorkspacePage } from "../WorkspacePages";

export default {
	id: "end-user.workspace",
	path: "/app/workspace",
	area: "end-user",
	navGroup: "",
	navIcon: "workspace",
	label: "ワークスペース",
	roles: ["tenant_member", "tenant_admin", "platform_admin"],
	backing: "ZEROVIA",
	enabled: true,
	component: WorkspacePage,
} satisfies ScreenModule;
